export default __webpack_public_path__ + "static/media/Destination1.6f44ec17.png";